import { gql } from '@apollo/client';

export const GET_CUSTOMER_TOS_STATUS = gql`
  query GetCustomerTOSStatus {
    customerTos {
      getTOSStatus {
        updateRequired
      }
    }
  }
`;
export const SET_CUSTOMER_TOS_ACCEPTED = gql`
  mutation SetCustomerTOSAccepted {
    customerTos {
      tOSAccepted {
        _empty
      }
    }
  }
`;
